import { CheckCircleFilled, CloseCircleFilled, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusCircleFilled } from '@ant-design/icons'
import { Button, Modal, Space, Table, Form, Input, Divider, Row, Col, Select } from 'antd'
import { groupLaporanDewan } from 'dummy/parameter'
import React, { useState } from 'react'
// import Select from 'routes/components/dataEntry/Select'

const FormItem = Form.Item
const label = {
    labelCol: {
        span: 24,
    },
    wrapperCol: {
        span: 24,
    },
};


export default function GroupKomisaris() {
    const [visible, setVisible] = useState(false)
    const [datas, setDatas] = useState({})
    const [titleModal, setTitleModal] = useState("Group Komponen Baru")
    const [form] = Form.useForm();
    // let titleModal = "Cabang Baru"

    const newCabang = () => {
        form.resetFields()
        setVisible(true)
        setTitleModal("Group Komponen Baru")
        setDatas({})
    }
    const confirm = (data) => {
        Modal.confirm({
            title: 'Konfirmasi',
            icon: <ExclamationCircleOutlined />,
            content: `Apakah anda yakin untuk menghapus ${data.name} ? Data akan terhapus secara permanen.`,
            okText: 'Hapus',
            cancelText: 'Tutup',
        });
    };


    const handleActiion = (record) => {
        return <Space><EditOutlined className="gx-text-primary" style={{ cursor: 'pointer' }} onClick={() => { setDatas(record); setVisible(true); setTitleModal("Edit Komponen") }} /> <DeleteOutlined className="gx-text-danger" onClick={() => confirm(record)} /></Space>
    }
    const columns = [
        {
            title: "Nama Group Komponen",
            dataIndex: "group",
            width: 200
        },
        {
            title: "Perhitungan",
            // dataIndex: "name",
            render: (record) => record.calculated ? <CheckCircleFilled style={{color : "green"}}/> : <CloseCircleFilled style={{color : "red"}}/>,
            width: 200
        },
        {
            title: "Aksi",
            width: 100,
            render: (record) => handleActiion(record),
            align: "right"
        }
    ]
    const onFinish = (value) => {
        console.log("finish", value)
    }


    return (
        <>
        <Row gutter={[8, 8]}>
            <Col lg={18} md={18} sm={12} xs={12}>
            <Input.Search placeholder="Cari Nama Group.."/>
            </Col>
            <Col  lg={6} md={6} sm={12} xs={12}>
            <Button className="gx-btn-block" type="primary" icon={<PlusCircleFilled />} onClick={() => newCabang()}>Komponen Baru</Button>
            </Col>
        </Row>
          
            <div className="gx-module-box-column">
                <Table dataSource={groupLaporanDewan} columns={columns} rowKey="id" rowClassName={(_record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'} />
                <Modal open={visible} onCancel={() => setVisible(false)} footer={null}>
                    <h3>{titleModal}</h3>
                    <Divider />
                    <Form
                        {...label}
                        name="control-hooks"
                        form={form}
                        onFinish={onFinish}
                        fields={[
                            {
                                name: ["name"],
                                value: datas.group
                            },
                            {
                                name: ["calculated"],
                                value: datas.calculated
                            }
                        ]}>
                        <FormItem name="name" rules={[{ required: true }]} label="Nama Group" >
                            <Input />
                        </FormItem>
                        <FormItem name="calculated" rules={[{ required: true }]} label="Perhitungan" >
                            <Select>
                                <Select.Option value={true}>Iya</Select.Option>
                                <Select.Option value={false}>Tidak</Select.Option>
                            </Select>
                        </FormItem>
        
                        <div className="gx-text-right">
                            <Button htmlType="submit" type="primary">Simpan</Button>
                        </div>
                    </Form>
                </Modal>
            </div>
        </>

    )
}
